import { Injectable } from '@angular/core';
import { ExternalAuthService } from 'src/app/auth/external-auth.service';

/**
 * Punto de decisión ÚNICO para saber si la firm actual tiene **Contratos v2**
 * activo (DEVS-380).
 *
 * Modela el mismo mecanismo que la visibilidad del módulo de Administración
 * (ver `aside.component.ts`):
 *
 * ```ts
 * // aside.component.ts
 * this.isGroupFirm = user.firm.administration_groups; // flag int a nivel firm
 * ```
 *
 * El flag vive en el objeto `firm` que devuelve `GET /api/users/{id}`
 * (`ExternalAuthService.getCurrentUser().firm`).
 *
 * ⚠️ [❓ pendiente — confirmar con Roy] El backend AÚN NO expone un flag propio de
 * Contratos v2: `Brevity.API/Models/FirmsModel.cs` solo tiene
 * `administration_groups` y `assemblies` como flags de módulo. Cuando el backend
 * agregue el flag (se espera un `int` con la misma convención que
 * `administration_groups`), su nombre real debe reflejarse acá — este service es
 * el único lugar que hay que tocar. Mientras el flag no exista en la respuesta,
 * `isV2Enabled()` devuelve `false` y la solapa societaria queda EXACTAMENTE como
 * hoy (legacy), sin romper nada.
 */
@Injectable({ providedIn: 'root' })
export class ContractsFeatureService {
  constructor(private auth: ExternalAuthService) {}

  /** ¿La firm actual tiene Contratos v2 activo? */
  isV2Enabled(): boolean {
    const firm: any = this.auth.getCurrentUser()?.firm;
    if (!firm) return false;

    // Espejo de `user.firm.administration_groups`. Nombre del flag pendiente de
    // confirmar con backend (ver JSDoc). Se contemplan los candidatos más
    // probables sin inventar comportamiento: si ninguno viene, => legacy.
    return Boolean(firm.contracts_v2 ?? firm.contracts ?? false);
  }
}
